module.exports = "../images/icons/icon-instagram.svg";